import { motion } from 'framer-motion';
import { proyects } from '../../Utils/data';
import { useEffect, useState } from 'react';
import Detail from './Detail';
import ButtonMenu from './ButtonMenu';
import { IoIosArrowBack, IoIosArrowForward } from "react-icons/io";
import useStore from '../../Store/store';

const Proyects = () => {
  const [startY, setStartY] = useState(null);
  const slide = useStore((state) => state.slide);
  const currentSlide = useStore((state) => state.currentSlide);

  const nextSlide = () => {
    currentSlide((slide + 1) % proyects.length); // Avanza al siguiente slide
  };

  const prevSlide = () => {
    currentSlide((slide - 1 + proyects.length) % proyects.length); // Retrocede al slide anterior
  };

  const handleTouchStart = (e) => {
    setStartY(e.touches[0].clientY);
  };

  const handleTouchEnd = (e) => {
    if (startY === null) return;
    const endY = e.changedTouches[0].clientY;
    const deltaY = startY - endY;

    if (Math.abs(deltaY) > 50) {
      const direction = deltaY > 0 ? 1 : -1;
      const newSlide = (slide + direction + proyects.length) % proyects.length;
      currentSlide(newSlide);
    }
    setStartY(null);
  };

  const handleScroll = (e) => {
    const direction = e.deltaY > 0 ? 1 : -1; // Scroll hacia abajo o arriba
    const newSlide = (slide + direction + proyects.length) % proyects.length; // Calcula el índice nuevo
    currentSlide(newSlide); // Actualiza el índice
  };

  useEffect(() => {
    window.addEventListener("wheel", handleScroll);
    window.addEventListener("touchstart", handleTouchStart);
    window.addEventListener("touchend", handleTouchEnd);

    return () => {
      window.removeEventListener("wheel", handleScroll);
      window.removeEventListener("touchstart", handleTouchStart);
      window.removeEventListener("touchend", handleTouchEnd);
    };
  }, [slide]);

  return (
    <div className="relative overflow-hidden h-screen items-center flex w-full">
      <motion.section
        className="absolute top-0 left-0 flex h-full"
        initial={{ x: 0 }}
        animate={{ x: `-${slide * 100}vw` }}
        transition={{
          ease: "easeInOut",
          duration: 0.5,
        }}
      >
        {proyects.map((project, index) => (
          <div
            key={project.id}
            className="h-full w-screen flex-shrink-0 bg-cover bg-center relative"
            style={{ backgroundImage: `url(${project.image})` }}
          >
              <Detail project={project} />
          </div>
        ))}
      </motion.section>
      <section className='absolute bottom-4 left-1/2 transform -translate-x-1/2 flex space-x-4'>
        <button
          onClick={prevSlide}
          className="text-persian bg-beige  p-4 rounded-full shadow-md hover:bg-gray-200 hover:scale-110 transition-all duration-300"
        >
          <IoIosArrowBack />
        </button>
        <button
          onClick={nextSlide}
          className="text-persian bg-beige p-4 rounded-full shadow-md hover:bg-gray-200 hover:scale-110 transition-all duration-300"
        >
          <IoIosArrowForward />
        </button>
      </section>
      <ButtonMenu proyects={proyects} />
    </div>
  );
};

export default Proyects;